import { call, delay, put, takeEvery } from "redux-saga/effects";
import axios, { all } from "axios";
import { API_URL } from "../../utils/constants";
import objectionTrackerActions from "./actions";
import Cookies from "js-cookie";
import commonActions from "../common/actions";

const objectionTrackerSagas = function* () {
  yield all([
    yield takeEvery(
      objectionTrackerActions?.GET_OBJECTION_QUESTION_DETAILS,getObjectionQuestionDetails,
    ),
    yield takeEvery(
      objectionTrackerActions?.UPDATE_OBJECTION_QUESTION_DETAILS,updateObjectionQuestionDetails
    ),
    yield takeEvery(
      objectionTrackerActions?.GET_OBJECTION_QUESTION_DETAILS_COUNT,getObjectionQuestionDetailsCount
    ),

   yield takeEvery(objectionTrackerActions.INITIALIZE_REFUND, createInitializeRefund),
   yield takeEvery(objectionTrackerActions.GET_REFUND_STATUS, getRefundStatus),


    
  ]);
};





const getObjectionQuestionDetails = function* (data) {
  const { payload } = data;
  
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/objectiontracker/objectionquestiondetails/${payload?.courseid}`
      )
    );


    
    // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: objectionTrackerActions.SET_OBJECTION_QUESTION_DETAILS,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
   

    // yield delay(2000);
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: { status: null, show: false, message: null },
    // });
  } catch (err) {
  }
};

const getObjectionQuestionDetailsCount = function* (data) {
  const { payload } = data;
  
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/objectiontracker/objectionquestiondetailscount`
      )
    );
    // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: objectionTrackerActions.SET_OBJECTION_QUESTION_DETAILS_COUNT,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
   

    // yield delay(2000);
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: { status: null, show: false, message: null },
    // });
  } catch (err) {
  }
};

const updateObjectionQuestionDetails = function* (data) {
  const { payload } = data;
  const navigate = payload?.navigate
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/objectiontracker/objectionquestiondetails/update/${payload?.objid}`,{
          status:payload?.status,comment:payload?.comment
        }
      )
    );
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: {
    //     status: result?.data?.statusCode == 200 ? "success" : "failed",
    //     show: true,
    //     message: result?.data?.message,
    //   },
    // });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
          status: (result?.data?.statusCode === 200) ? 'success' : 'failed',
          show: true,
          message: result?.data?.message
      }
  });
// if(result?.data?.statusCode == 200){

  navigate(`/${Cookies.get('mhet_mst_project')}/view-objections`);
  
// } 
    
yield delay(2000)
 yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: objectionTrackerActions.SET_OBJECTION_QUESTION_DETAILS,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
    
    yield put({
      type: objectionTrackerActions.GET_OBJECTION_QUESTION_DETAILS,
      payload: { courseid: payload?.courseid },
    });


    
    // yield delay(2000);
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: { status: null, show: false, message: null },
    // });
  } catch (err) {
  }
};


const createInitializeRefund = function* (data) {
  const { payload } = data;

  

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/payu/create-refund`, payload)
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: objectionTrackerActions.GET_REFUND_STATUS,
      payload: result?.data?.statusCode === 200 ? result?.data : [],
    });
    
  yield delay(2000)
       yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getRefundStatus = function* (data) {
  
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/payu/get-refund`
      )
    );
    
    yield put({
      type: objectionTrackerActions.SET_REFUND_STATUS,
      payload: result?.data?.statusCode === 200 ? result?.data : [],
    });
  
   
  } catch (err) {
  }
};



export default objectionTrackerSagas;
